// extracted by mini-css-extract-plugin
module.exports = {"scroll":"landing_scroll__34ygy"};